import React from 'react'

function Imgsec() {
    return (
        <section className='px-3 pb-3 '>
            <div className='heroImg d-flex align-items-center justify-content-center flex-column h-100'>
                <h1>
                <span className='d-block text-right'> The Future </span> 
               <span className='d-block text-left'> of Health </span>
                <span className='d-block text-center'>— is clear.</span>
            <button className='butn butn-round d-block mx-auto'>
                    Show More
            </button>
                </h1>
            </div>
            

        </section>
    )
}

export default Imgsec
